export default "__VITE_ASSET__DdPKUpzA__"